import React from 'react';
import { Button, Icon, Modal } from '@aidkitorg/component-library';
import { useLocalizedStrings } from '../../../Localization';
import { Report } from '../../../Contexts/ReportsContext';

type ReportExportModalProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  report: Report | null;
}

export const ReportExportModal: React.FC<ReportExportModalProps> = ({
  open,
  setOpen,
  report
}) => {
  const L = useLocalizedStrings();

  const handleExportCSV = () => {
    // Placeholder for CSV export functionality
    console.log('Export as CSV clicked for report:', report?.title);
    // TODO: Implement CSV export logic
  };

  const handleExportXLSX = () => {
    // Placeholder for XLSX export functionality
    console.log('Export as XLSX clicked for report:', report?.title);
    // TODO: Implement XLSX export logic
  };

  return (
    <Modal
      title={L.admin_panel.reports.export_report}
      open={open}
      onClose={() => setOpen(false)}
    >
      <div className="pb-4">
        {L.admin_panel.reports.export_reports_desc}
      </div>
      <div className="flex flex-col gap-y-2">
        <Button
          onClick={handleExportCSV}
          variant="secondary"
          className="!justify-start"
        >
          <div className="flex gap-4 items-center py-2">
            <Icon name="ArrowDownTrayIcon" role='decorative'/>
            <div className="!text-left">
              <div>{L.admin_panel.payments.csv_format}</div>
              <div className="font-light">
                {L.admin_panel.payments.csv_format_desc}
              </div>
            </div>
          </div>
        </Button>
        <Button
          onClick={handleExportXLSX}
          variant="secondary"
          className="!justify-start"
        >
          <div className="flex gap-4 items-center py-2">
            <Icon name="TableCellsIcon" role='decorative'/>
            <div className="!text-left">
              <div>{L.admin_panel.payments.xlsx_format}</div>
              <div className="font-light">
                {L.admin_panel.payments.xlsx_format_desc}
              </div>
            </div>
          </div>
        </Button>
      </div>
    </Modal>
  );
};

export default ReportExportModal;
